import React, { Component } from 'react';
//import { Link } from 'react-router-dom';
import './cancelloComponent.css';
import { Spinner } from 'react-bootstrap';
import AutenticationService from '../services/authservice.js';
import CancelloSrv from '../services/Api/Cancello/Cancello.js';

export default class CancelloComponent extends Component {
  state = {
    loading: false,
    loadingclose: false,
    msgremote: 'messaggio di ritorno',
    msgremoteopen: 'messaggio di ritorno open',
  };

  componentDidMount(props) {
    console.log('componentDidMount padre :', this.props);
    this.setState({
      history: this.props.history,
    });
debugger;
    this.getOpenCloseCancello("");
    //console.log('ciccio :', JSON.parse(this.props.match.params.id));
    // this.setState({
    //   // id: this.props.match.params.id,
    //   msgremoteopen: 'messaggio di ritorno open',
    //   msgremote: 'messaggio di ritorno close',
    // });
  }

  handleError = (error, id) => {
    console.log(error);
    let mes = '';
    try {
      if (error.response.data) {
        mes = error.response.data.msgc;
      } else {
        mes = error;
      }
    } catch (e) {
      mes = error;
    }
    this.setMesRemo(mes, id);
    // this.setState({ msgremoteopen: mes });
    // switch (id) {
    //   case 'open':
    //     this.setState({ msgremoteopen: mes });
    //     break;
    //   case 'close':
    //     this.setState({ msgremote: mes });
    //     break;
    //   default:
    //     console.log('case non definito');
    //     break;
    // }

    // this.setState({ loading: false });
    // this.setState({ loadingclose: false });
    if (error.response.data.status === 403) {
      setTimeout(() => {
        if (this.state.history) this.state.history.push('/login/login');
      }, 3000);
    }
  };
  handleResponse = (response, id) => {
    debugger;
    console.log(
      'OUTPUT: CancelloComponent -> handleResponse -> response',
      response
    );
    this.setMesRemo(response.data.msgc, id);
    // this.setState({ loading: false });
    // this.setState({ loadingclose: false });
    // this.setState({ msgremoteopen: 'aaaaaaaaaaaaaaaaaa' });
  };
  setMesRemo = (mes, id) => {
    switch (id) {
      case 'open':
        this.setState({ msgremoteopen: mes, msgremote: mes });
        break;
      case 'close':
        this.setState({ msgremote: mes, msgremoteopen: mes });
        break;
      case 'onoff':
        this.setState({ msgremoteopen: mes, msgremote: mes });
        break;
      default:
        console.log('case non definito');
        break;
    }
    this.setState({ loading: false });
    this.setState({ loadingclose: false });
  };
  render() {
    return (
      <div className='py-5 CancelloComponent'>
        <div className='container-fluid'>
          <section className='py-2'>
            <h3 className='mb-2 text-center'>
              <b>Servizio Cancello</b>
            </h3>
          </section>
          <div className='row'>
            <div className='col-sm-1'></div>
            <div className='col-sm-10 '>
              <button
                className='mt-2 btn btn-primary mybut'
                //href='#'
                onClick={this.OpenCancello}
              >
                <div className='text-left lead'>
                  <i className='p-2 fas fa-snowflake '>
                    {this.state.loading && (
                      <Spinner animation='border' role='status'></Spinner>
                    )}
                  </i>
                </div>

                <h2>
                  <b>Premi per Aprire</b>
                </h2>
               
                <div className='text-left lead'>     
                  <h3>{this.state.msgremoteopen} </h3>
                </div>
                
              </button>
            </div>
            <div className='col-sm-1'></div>
          </div>

          <div className='py-4 row'>
            <div className='col-sm-1'></div>
            <div className='col-sm-10'>
              <button
                className='mt-2 btn btn-success mybut'
                //href='#'
                onClick={this.CloseCancello}
              >
                <div className='text-left lead'>
                  <i className='p-2 fas fa-snowflake '>
                    {this.state.loadingclose && (
                      <Spinner animation='border' role='status'></Spinner>
                    )}
                  </i>
                </div>

                <h2>
                  <b>Premi per Chiudere</b>
                </h2>
                <div className='text-left lead'><h3>{this.state.msgremote}</h3></div>
              </button>
            </div>
            <div className='col-sm-1'></div>
          </div>
        </div>
      </div>
    );
  }
  getOpenCloseCancello = (event) => {
    debugger;
    console.log(
      'OUTPUT: CancelloComponent -> OpenCancelloOnOff -> ',
      //event.target.innerText
    );
    this.setState({ loading: true });
    this.setState({ loadingclose: false });
    const idute = AutenticationService.getIdUte();
    const data = { id: 1, method: 'onoff', timer: 0, idute: idute, onoff :'1' };
    this.setState({ msgremoteopen: 'Avvio Richiesta Open Cancello' });

    CancelloSrv.getOpenCancelloBasic(data)
      .then((response) => this.handleResponse(response, 'onoff'))
      .catch((error) => this.handleError(error, 'onoff'));
    
  };
  OpenCancello = (event) => {
    console.log(
      'OUTPUT: CancelloComponent -> OpenCancello -> ',
      event.target.innerText
    );
    this.setState({ loading: true });
    this.setState({ loadingclose: false });
    const idute = AutenticationService.getIdUte();
    const data = { id: 1, method: 'open', timer: 0, idute: idute, onoff :'0' };
    this.setState({ msgremoteopen: 'Avvio Richiesta Open Cancello' });

    CancelloSrv.getOpenCancelloBasic(data)
      .then((response) => this.handleResponse(response, 'open'))
      .catch((error) => this.handleError(error, 'open'));
    //const timer = onoff === 1 ? 1 : 0;
    //let token = getToken();
    //const data = { id: onoff, method: 'open', timer: 0 };
    //const url = window.location.href.split('#')[0] + 'open';
    //const url = 'https://192.168.1.26:8443/open'; //url.replace('http://', 'https://');

    // RemoteC.render(data, url, 'POST', setResult, token);
    // function setResult(data) {
  };
  CloseCancello = (event) => {
    console.log(
      'OUTPUT: CancelloComponent -> CloseCancello -> ',
      event.target.innerText
    );
    this.setState({ msgremote: 'Avvio Richiesta Close Cancello' });
    const idute = AutenticationService.getIdUte();
    const data = { id: 0, method: 'close', timer: 0, idute: idute, onoff :'1' };
    CancelloSrv.getOpenCancelloBasic(data)
      .then((response) => this.handleResponse(response, 'close'))
      .catch((error) => this.handleError(error, 'close'));
    this.setState({ loading: false });
    this.setState({ loadingclose: true });
  };
}

/* <div className='mt-5 CancelloComponent'>
        <div className='container-fluid'>
          <section className='py-3'>
            <div className='container text-center'>
              <h3 className='mb-2'>Apre Chiude il Cancello</h3>

              <button
                className='mt-2 btn btn-primary mybut'
                //href='#'
                onClick={this.OpenCancello}
              >
                <h1>
                  <b>Apre</b>
                </h1>
                <p className='text-left lead'>messaggio di ritorno</p>
              </button>
            </div>

            <div className='container py-4 text-center'>
              <button
                className='mt-2 btn btn-primary mybut'
                //href='#'
                onClick={this.CloseCancello}
              >
                <h1>
                  <b>Chiude</b>
                </h1>
                <p className='text-left lead'>messaggio di ritorno</p>
              </button>
            </div>
          </section>
        </div>
      </div> */


// + - / *

